import { Component, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { Location, DatePipe } from '@angular/common';
import { BaseWidget } from 'src/app/tools/abstract-classes/base-widget';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { RoleTargetKpisService } from 'src/app/assabil-sales/services/role-target-kpis-service';
import { Role } from 'src/app/assabil-kernel/models/entities/master-data/role-entity';
import { BaseEntity } from 'src/app/tools/models/baseEntity';
import { LeanDataFormComponent } from 'src/app/tools/components/lean-data-form/lean-data-form.component';
import { MasterDataService } from 'src/app/assabil-kernel/services/master-data-service';
import { marker } from 'src/app/tools/models/entities/marker';
import { Partner } from 'src/app/assabil-kernel/models/entities/master-data/partner-entity';
import { Chart } from 'node_modules/chart.js';

  @Component({
    selector: 'role-target-monitoring-widget',
    templateUrl: './role-target-monitoring-widget.component.html',
    styleUrls: ['./role-target-monitoring-widget.component.scss']
  })
  
  export class RoleTargetMonitoringWidgetComponent extends BaseWidget {

    @ViewChild('leanDataForm', {static : false}) leanDataForm : LeanDataFormComponent;
  
    //roleField = { prop: "roleCode", name: "Role", readOnly: false, modal :  RoleLovComponent};
  
    //filterRole    : Role = new Role();
    date          : Date = new Date();  
    date1         : Date = new Date(); 
    rootRole      : Role; 
    selectedRole  : Role; 
    roleCode      : string;
  
    base          : string = "order";

    role                    : Role;
    clickedRoleContainer    : Role[] = [null]; // to have on cell in the Array
    ready         : boolean = false;
    successRate   : number;
    coverageRate  : number;
  
    points        : marker[] = [];
    longitude     : number;
    latitude      : number;
    title         : string = "Dashboard Performance globale";
  
    
    constructor(
      protected datepipe: DatePipe,
      protected roleTargetKpisService  :  RoleTargetKpisService,
      protected leanUtilsService        : LeanUtilsService,
      protected masterDataService       : MasterDataService,
      protected toastr                  : ToastrService,
      protected router                  : Router,
      protected location                : Location) {
        super(toastr, leanUtilsService);
  
    }
  
  //----------------------------------------------------------------------
  ngOnInit(){
    this.date.setDate(this.date.getDate() - 1);
    super.ngOnInit();
    this.masterDataService.personRoleGet('sales').then(result => {
      this.rootRole = result;
    })
  }
  //----------------------------------------------------------------------
  selectRoleAndGo(role : Role){ 
    this.selectRole(role);
    this.leanDataForm.hideFilter();
    this.loadData(null);
  }
  selectRole(role : Role){
    if (this.selectedRole != null) this.selectedRole.selected = false;
    this.selectedRole = role;
    this.selectedRole.selected=true;
    this.roleCode = this.selectedRole.roleCode;
  }
  //----------------------------------------------------------------------

  //----------------------------------------------------------------------
  loadData(roleInMap : Role) {
      if ( (! this.roleCode) ||   (! this.date) ){
        this.toastr.error("Prière de précisier les paramètres de la recherhe");
        return;
      }
      
      let basedOnInvoice =  (this.base=='invoice');
      this.roleTargetKpisService.getRoleTargetKpis(this.roleCode, 'sales', this.date, basedOnInvoice, ! basedOnInvoice).then(role => {
        if (this.role) {
          this.merge(role, this.role);
        }
        this.role = role;
        this.ready = true;
        this.title = "Dashboard Performance globale - MTD : " + this.datepipe.transform(this.date, 'dd/MM/yyyy') + " | " + this.selectedRole.name;

        if (roleInMap) {
          this.clickedRoleContainer[0] = roleInMap;
          this.roleClicked();
        }
      })
    }
  //----------------------------------------------------------------------



  merge(role : Role , odlRole : Role){
    role.expanded = odlRole.expanded;
    if (role.subRoles) {
      for (let subRole of role.subRoles){
        let subOldRole : Role = null;
        for (let sor of odlRole.subRoles){
            if (subRole.roleCode == sor.roleCode) {
              subOldRole =  sor;
            }
        }
        if (subOldRole) {
          this.merge(subRole, subOldRole);
        }
      }
    }
  }

  returnBack(){
    this.location.back();
  }

  getRate(v1 : number, v2 : number) : number{
    let rate =  v1 * 100 / v2;
    rate = Math.round(rate * 100 / 100);
    return rate;
  }


  clickedRole : Role;
  showInMap : boolean = false;
  roleClicked(){
    if (this.clickedRoleContainer[0] == null) {
      this.clickedRoleContainer[0] = this.role;
    }
    this.clickedRole  = this.clickedRoleContainer[0]
    if ( this.clickedRole.subRoles){
      this.clickedRole.expanded = ! this.clickedRole.expanded;
      return;
    }
  }


  onSelectPoint(index : number) {
    let point   : marker = this.points[index];
    point.animation = '';
  }
  onMapClick(e :  any){

  }

  //--------------------------------------------------------------------------------------
  setEntity(data: BaseEntity) {
    throw new Error("Method not implemented.");
  }
  getEntity(): BaseEntity {
    throw new Error("Method not implemented.");
  }
  saveRow(): Promise<BaseEntity> {
    throw new Error("Method not implemented.");
  }
  //--------------------------------------------------------------------------------------
    
  }
  
  